import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import Home from '../containers/Expedition/PickingRoute/Home';
import PickingRouteInsert from '../containers/Expedition/PickingRoute/PickingRouteInsert';
import PickingRouteList from '../containers/Expedition/PickingRoute/RoutesList/PickingRoute';
import HomeRouteUser from '../containers/Expedition/PickingRoute/RouteUser/Home';
import PickingRouteUser from '../containers/Expedition/PickingRoute/RouteUser/PickingRouteUser';
import PickingRouteUserList from '../containers/Expedition/PickingRoute/RouteUser/PickingRouteUserList';

import HomePduLocationTarget from '../containers/Expedition/PickingRoute/PduLocationTarget/Home';
import PduLocationTarget from '../containers/Expedition/PickingRoute/PduLocationTarget/PduLocationTarget';
import PduLocationTargetList from '../containers/Expedition/PickingRoute/PduLocationTarget/PduLocationTargetList';

let aux = 0;
const pathurl = getPathApp(window);
const RoutePickingRoute = [

    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/pdulocationtarget/List`} component={PduLocationTargetList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/pdulocationtarget/insert`} component={PduLocationTarget} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/pdulocationtarget`} component={HomePduLocationTarget} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/routeUser/list`} component={PickingRouteUserList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/routeUser/insert`} component={PickingRouteUser} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/routeUser`} component={HomeRouteUser} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/insert`} component={PickingRouteInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking/list`} component={PickingRouteList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/routePicking`} component={Home} />,
];

export default RoutePickingRoute;
